function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 24,
  fill: "#C7CBDD"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4914_1332)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.2188 12.7688H17.3813C16.5321 12.7688 15.8438 13.4571 15.8438 14.3063V34.2938C15.8438 35.1429 16.5321 35.8313 17.3813 35.8313H31.2188C32.0679 35.8313 32.7563 35.1429 32.7563 34.2938V14.3063C32.7563 13.4571 32.0679 12.7688 31.2188 12.7688Z",
  stroke: "#52545E",
  strokeWidth: 1.5375,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.9125 15.8438H19.6875C19.2629 15.8438 18.9187 16.1879 18.9187 16.6125V19.6875C18.9187 20.1121 19.2629 20.4563 19.6875 20.4563H28.9125C29.337 20.4563 29.6812 20.1121 29.6812 19.6875V16.6125C29.6812 16.1879 29.337 15.8438 28.9125 15.8438Z",
  stroke: "#52545E",
  strokeWidth: 1.5375,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.0719 24.3C20.1479 24.3 20.2222 24.3226 20.2854 24.3648C20.3486 24.407 20.3979 24.4671 20.427 24.5373C20.4561 24.6075 20.4637 24.6848 20.4489 24.7594C20.434 24.8339 20.3974 24.9024 20.3437 24.9562C20.2899 25.0099 20.2214 25.0466 20.1469 25.0614C20.0723 25.0762 19.995 25.0686 19.9248 25.0395C19.8545 25.0104 19.7945 24.9612 19.7523 24.8979C19.71 24.8347 19.6875 24.7604 19.6875 24.6844C19.6875 24.5825 19.728 24.4847 19.8001 24.4126C19.8722 24.3405 19.9699 24.3 20.0719 24.3Z",
  fill: "#52545E",
  stroke: "#52545E",
  strokeWidth: 1.5375,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.4599 24.3C24.536 24.3 24.6103 24.3226 24.6735 24.3648C24.7367 24.407 24.786 24.4671 24.8151 24.5373C24.8441 24.6075 24.8518 24.6848 24.8369 24.7594C24.8221 24.8339 24.7855 24.9024 24.7317 24.9562C24.678 25.0099 24.6095 25.0466 24.5349 25.0614C24.4604 25.0762 24.3831 25.0686 24.3128 25.0395C24.2426 25.0104 24.1826 24.9612 24.1403 24.8979C24.0981 24.8347 24.0756 24.7604 24.0756 24.6844C24.0756 24.5825 24.1161 24.4847 24.1881 24.4126C24.2602 24.3405 24.358 24.3 24.4599 24.3",
  stroke: "#52545E",
  strokeWidth: 1.5375,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.5281 24.3C28.6041 24.3 28.6785 24.3226 28.7417 24.3648C28.8049 24.407 28.8541 24.4671 28.8832 24.5373C28.9123 24.6075 28.9199 24.6848 28.9051 24.7594C28.8903 24.8339 28.8537 24.9024 28.7999 24.9562C28.7462 25.0099 28.6777 25.0466 28.6031 25.0614C28.5285 25.0762 28.4513 25.0686 28.381 25.0395C28.3108 25.0104 28.2508 24.9612 28.2085 24.8979C28.1663 24.8347 28.1437 24.7604 28.1437 24.6844C28.1437 24.5825 28.1842 24.4847 28.2563 24.4126C28.3284 24.3405 28.4262 24.3 28.5281 24.3Z",
  fill: "#52545E",
  stroke: "#52545E",
  strokeWidth: 1.5375,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.0719 28.1438C20.1479 28.1438 20.2222 28.1663 20.2854 28.2085C20.3486 28.2508 20.3979 28.3108 20.427 28.381C20.4561 28.4513 20.4637 28.5286 20.4489 28.6031C20.434 28.6777 20.3974 28.7462 20.3437 28.7999C20.2899 28.8537 20.2214 28.8903 20.1469 28.9051C20.0723 28.92 19.995 28.9124 19.9248 28.8833C19.8545 28.8542 19.7945 28.8049 19.7523 28.7417C19.71 28.6785 19.6875 28.6042 19.6875 28.5281C19.6875 28.4262 19.728 28.3284 19.8001 28.2563C19.8722 28.1843 19.9699 28.1438 20.0719 28.1438Z",
  fill: "#52545E",
  stroke: "#52545E",
  strokeWidth: 1.5375,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.4599 28.1438C24.536 28.1438 24.6103 28.1663 24.6735 28.2085C24.7367 28.2508 24.786 28.3108 24.8151 28.381C24.8441 28.4513 24.8518 28.5286 24.8369 28.6031C24.8221 28.6777 24.7855 28.7462 24.7317 28.7999C24.678 28.8537 24.6095 28.8903 24.5349 28.9051C24.4604 28.92 24.3831 28.9124 24.3128 28.8833C24.2426 28.8542 24.1826 28.8049 24.1403 28.7417C24.0981 28.6785 24.0756 28.6042 24.0756 28.5281C24.0756 28.4262 24.1161 28.3284 24.1881 28.2563C24.2602 28.1843 24.358 28.1438 24.4599 28.1438",
  stroke: "#52545E",
  strokeWidth: 1.5375,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.5281 28.1438C28.6041 28.1438 28.6785 28.1663 28.7417 28.2085C28.8049 28.2508 28.8541 28.3108 28.8832 28.381C28.9123 28.4513 28.9199 28.5286 28.9051 28.6031C28.8903 28.6777 28.8537 28.7462 28.7999 28.7999C28.7462 28.8537 28.6777 28.8903 28.6031 28.9051C28.5285 28.92 28.4513 28.9124 28.381 28.8833C28.3108 28.8542 28.2508 28.8049 28.2085 28.7417C28.1663 28.6785 28.1437 28.6042 28.1437 28.5281C28.1437 28.4262 28.1842 28.3284 28.2563 28.2563C28.3284 28.1843 28.4262 28.1438 28.5281 28.1438Z",
  fill: "#52545E",
  stroke: "#52545E",
  strokeWidth: 1.5375,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.0719 31.9875C20.1479 31.9875 20.2222 32.0101 20.2854 32.0523C20.3486 32.0945 20.3979 32.1546 20.427 32.2248C20.4561 32.295 20.4637 32.3723 20.4489 32.4469C20.434 32.5214 20.3974 32.5899 20.3437 32.6437C20.2899 32.6974 20.2214 32.7341 20.1469 32.7489C20.0723 32.7637 19.995 32.7561 19.9248 32.727C19.8545 32.6979 19.7945 32.6487 19.7523 32.5854C19.71 32.5222 19.6875 32.4479 19.6875 32.3719C19.6875 32.27 19.728 32.1722 19.8001 32.1001C19.8722 32.028 19.9699 31.9875 20.0719 31.9875Z",
  fill: "#52545E",
  stroke: "#52545E",
  strokeWidth: 1.5375,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.4599 31.9875C24.536 31.9875 24.6103 32.0101 24.6735 32.0523C24.7367 32.0945 24.786 32.1546 24.8151 32.2248C24.8441 32.295 24.8518 32.3723 24.8369 32.4469C24.8221 32.5214 24.7855 32.5899 24.7317 32.6437C24.678 32.6974 24.6095 32.7341 24.5349 32.7489C24.4604 32.7637 24.3831 32.7561 24.3128 32.727C24.2426 32.6979 24.1826 32.6487 24.1403 32.5854C24.0981 32.5222 24.0756 32.4479 24.0756 32.3719C24.0756 32.27 24.1161 32.1722 24.1881 32.1001C24.2602 32.028 24.358 31.9875 24.4599 31.9875",
  stroke: "#52545E",
  strokeWidth: 1.5375,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.5281 31.9875C28.6041 31.9875 28.6785 32.0101 28.7417 32.0523C28.8049 32.0945 28.8541 32.1546 28.8832 32.2248C28.9123 32.295 28.9199 32.3723 28.9051 32.4469C28.8903 32.5214 28.8537 32.5899 28.7999 32.6437C28.7462 32.6974 28.6777 32.7341 28.6031 32.7489C28.5285 32.7637 28.4513 32.7561 28.381 32.727C28.3108 32.6979 28.2508 32.6487 28.2085 32.5854C28.1663 32.5222 28.1437 32.4479 28.1437 32.3719C28.1437 32.27 28.1842 32.1722 28.2563 32.1001C28.3284 32.028 28.4262 31.9875 28.5281 31.9875Z",
  fill: "#52545E",
  stroke: "#52545E",
  strokeWidth: 1.5375,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4914_1332"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24.6,
  height: 24.6,
  fill: "white",
  transform: "translate(12 12)"
})));

function SvgCalculatorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorIcon);
export default __webpack_public_path__ + "static/media/calculator-icon.6eb483d0.svg";
export { ForwardRef as ReactComponent };